import React, { useEffect, useRef, useState } from 'react';
import './AuthComponent.css';

const ModalComponent = ({ isOpen, onClose, onAgree }) => {
    const [canAgree, setCanAgree] = useState(false);
    const modalContentRef = useRef(null);

    const handleScroll = () => {
        if (modalContentRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = modalContentRef.current;
            if (scrollTop + clientHeight === scrollHeight) {
                setCanAgree(true);
            }
        }
    };

    useEffect(() => {
        if (modalContentRef.current) {
            const { scrollHeight, clientHeight } = modalContentRef.current;
            if (scrollHeight <= clientHeight) {
                setCanAgree(true);
            } else {
                modalContentRef.current.addEventListener('scroll', handleScroll);
            }
        }
        return () => {
            if (modalContentRef.current) {
                modalContentRef.current.removeEventListener('scroll', handleScroll);
            }
        };
    }, [isOpen]);

    return (
        isOpen && (
            <div className="modal open">
                <div className="modal-content" ref={modalContentRef}>
                    <h3>▼imavo RECのご利用にあたって</h3>
                    <ul>
                        <li>ご確認いただきたい内容
                            <ul>
                                <li>当Webサービスをご自由にコンテンツ制作にご利用ください
                                </li>
                                <li>制作上で生まれたサービスに対する疑問や質問、改善点、気に入っていただけた点、などを随時ご連絡ください
                                    <ul>
                                        <li>運営側とのコミュニケーション用に、Discordサーバーをご用意しておりますので、ご利用ください</li>
                                        <li>Discordアカウントをお持ちでない方は、別の連絡手段にて、同様の内容をご連絡ください（メール、XでのDMなど）</li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li>ご利用にあたっての注意点
                            <ul>
                                <li>当サービスで制作いただいたコンテンツは、YoutubeやSNSでのアップなどご自由にご使用ください</li>
                                <li>当サービスは開発中のβ版であり、今後予告なくサービスアップデート、サービス停止を行う可能性がございますのであらかじめご了承ください</li>
                                <li>当サービスを利用したことによる損害、トラブル等については、当サービス運営側は一切責任を負いません</li>
                            </ul>
                        </li>
                    </ul>
                    <div className="modal-buttons">
                        <button onClick={onAgree} className="agree-button" disabled={!canAgree}>確認しました</button>
                        <button onClick={onClose} className="close-button">閉じる</button>
                    </div>
                </div>
            </div>
        )
    );
};

export default ModalComponent;
